import React, { useEffect, useState } from "react";
import "./QuickCardsHomepage.css";
// import Image from "next/image";
import { Eye, Image } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Banner from "./Banner";
import toast from "react-hot-toast";
import Helpers from "../Helper/Helpers";
import { useAuth } from "../context/AuthContextAdmin";
import MovingHeader from "./MovingHeader";
import SocialMediaIcons from "./SocialMediaIcons";
import EcommerceLogos from "./EcommerceLogos";

const QuickCardsHomePage = () => {
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const productsPerPage = 6;
  const [products, setProduct] = useState([]);
  const [arivalProducts, setNewArrivalProduct] = useState([]);
  const { fetchProducts } = useAuth();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    getAllProductData();
    getAllNewArrivalProductData();
  }, []);

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const getAllProductData = async () => {
    const res = await Helpers(`/admin/product/bestsellers`, "GET");
    if (res && res?.status) {
      setProduct(res?.data);
    } else {
      toast("Failed to fetch product data!");
    }
  };

  const getAllNewArrivalProductData = async () => {
    const res = await Helpers(`/admin/product/new-arrivals`, "GET");
    if (res && res?.status) {
      setNewArrivalProduct(res?.data);
    } else {
      toast("Failed to fetch product data!");
    }
  };
  // const products = [
  //   {
  //     title: "MAGIC QR CODE",
  //     category: "REVIEWS CARDS",
  //     description:
  //       "The Magic Google Review QR Code helps collect positive reviews, filters out negative feedback.",
  //     price: 999,
  //     originalPrice: 4999,
  //     image: ["/10A.jpg", "/10B.jpg", "/10C.jpg", "/10D.jpg"],
  //   },

  // ];

  const [categories, setCategoriess] = useState([]);
  useEffect(() => {
    getAllSubCategory();
  }, []);

  const CustomPrevArrows = (props) => (
    <div
      onClick={props.onClick}
      style={{
        position: "absolute",
        left: "-25px",
        top: "40%",
        zIndex: 1,
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundColor: "#333", // dark color
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
      }}
    >
      &#60;
    </div>
  );

  const CustomNextArrows = (props) => (
    <div
      onClick={props.onClick}
      style={{
        position: "absolute",
        right: "-25px",
        top: "40%",
        zIndex: 1,
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundColor: "#000", // dark color
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
      }}
    >
      &#62;
    </div>
  );

  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrows />,
    nextArrow: <CustomNextArrows />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const getAllSubCategory = async () => {
    const res = await Helpers(`/admin/subcategory/get`, "GET");
    if (res && res?.status) {
      setCategoriess(res?.data);
    } else {
    }
  };

  const handleCategorywiseProduct = async (catId, subCatId) => {
    if (catId && subCatId) {
      let data = {
        category: catId,
        subcategory: subCatId,
      };
      const res = await Helpers(
        `/admin/product/get-by-category-subcategory`,
        "POST",
        data
      );
      if (res && res?.status) {
        navigate("/categorywiseproduct", { state: res?.data });
        // setCatWiseProduct(res?.data);
      } else {
      }
    }
  };

  const CategoryCard = ({ category }) => {
    return (
      <div
        className="category-item"
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div
          className="image-container"
          style={{
            width: "130px",
            height: "130px",
            borderRadius: "10px",
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <img
            src={category?.image}
            alt={category?.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </div>
        <h3
          style={{
            fontSize: "1rem",
            fontWeight: "800",
            color: "#333",
            margin: 0,
            padding: "0 4px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "110px",
          }}
          title={category?.name}
        >
          {category?.name}
        </h3>
      </div>
    );
  };

  const HandleAddTocart = async (productId) => {
    if (productId) {
      const res = await Helpers(
        `/admin/product/${productId}/toggle-cart`,
        "PUT"
      );
      if (res && res?.status) {
        toast.success(res?.message);
        getAllProductData();
        getAllNewArrivalProductData();
        fetchProducts();
      } else {
        console.log("Failed to add data to cart");
      }
    }
  };

  const totalPages = Math.ceil(products.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;

  const currentProducts = products.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const currentProducts1 = arivalProducts?.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const addToCart = () => {
    setCartCount((prevCount) => prevCount + 1);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const testimonials = [
    {
      rating: 5,
      text: "I have 2 restaurants and ordered 10 cards for each location. I am very impressed with how well these work.",
      name: "Rahul Sharma",
      designation: "restaurant owner",
      image: "/cus2.jpeg",
    },
    {
      rating: 5,
      text: "Xcess Support Team did a great job helping us change the links on our cards. It's a fantastic products and haven't ran into any issues yet so thank you!",
      name: "Dr. Singh",
      designation: "Doctor",
      image: "/cus1.jpeg",
    },
    {
      rating: 5,
      text: "Xcess has revolutionized the way I collect customer reviews! The Google Review cards have made it so easy for my customers to leave feedback.",
      name: "Sarah M",
      designation: "Boutique Owner",
      image: "/cus4.jpeg",
    },
  ];

  const banners = [
    {
      id: 1,
      src: "/XcessBanner1.webp",
      alt: "Mechanical Keyboards - Precision and Speed",
      title: "Upgrade Your Setup with Premium Keyboards",
      buttonText: "Shop Now",
    },
    {
      id: 2,
      src: "/XcessBanner2.webp",
      alt: "Gaming Mouse - Dominate Your Gameplay",
      title: "Precision Gaming with High-Speed Mouse",
      buttonText: "Explore Now",
    },
    {
      id: 3,
      src: "/XcessBanner3.webp",
      alt: "Headphones - Crystal Clear Audio for Gamers",
      title: "Crystal Clear Audio for Gamers",
      buttonText: "Buy Now",
    },
  ];

  const CustomPrevArrow = ({ onClick }) => (
    <div
      style={{
        position: "absolute",
        left: "-20px",
        top: "40%",
        zIndex: 1,
        fontSize: "24px",
        color: "#7f8c8d", // custom color
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <FaChevronLeft />
    </div>
  );

  const CustomNextArrow = ({ onClick }) => (
    <div
      style={{
        position: "absolute",
        right: "-20px",
        top: "40%",
        zIndex: 1,
        fontSize: "24px",
        color: "#7f8c8d", // custom color
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <FaChevronRight />
    </div>
  );

  const settingss = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    swipe: false, // disable swipe on desktop
    draggable: false, // disable drag on desktop
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          swipe: false,
          draggable: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          swipe: true, // ✅ enable swipe on mobile
          draggable: true, // ✅ enable drag on mobile
          arrows: false, // optional: hide arrows on mobile for cleaner look
        },
      },
    ],
  };
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="quick-cards-homepage">
      <Banner />
      {/* Moving header */}
      <MovingHeader />
      {/* Categories Section */}
      <section
        className="categories-section"
        style={{ padding: "20px 0", position: "relative" }}
      >
        {/* Heading */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "20px",
            fontFamily:
              '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
          }}
        >
          {/* Left: Title */}
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              borderBottom: "3px solid #fbc02d",
              display: "inline-block",
              paddingBottom: "4px",
            }}
          >
            Popular Categories
          </h2>

          {/* Right: Toggle Button */}
          <button
            onClick={() => setShowAll(!showAll)}
            style={{
              padding: "6px 14px",
              fontSize: "12px",
              fontWeight: "bold",
              color: "white",
              background: "#4caf50",
              border: "none",
              borderRadius: "30px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              fontFamily:
                '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
            }}
          >
            {showAll ? "<< Show Less >>" : "<< Show All >>"}
          </button>
        </div>

        {/* Slider or Grid View */}
        {!showAll ? (
          <Slider {...settingss} className="category-grid">
            {categories.map((category, index) => (
              <div
                key={index}
                onClick={() =>
                  handleCategorywiseProduct(
                    category?.categoryid?._id,
                    category?._id
                  )
                }
              >
                <CategoryCard category={category} />
              </div>
            ))}
          </Slider>
        ) : (
          <div
            className="category-grid-expanded"
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "repeat(2, 1fr)" // 2 columns on mobile
                : "repeat(auto-fill, minmax(120px, 1fr))", // Auto-fit on larger screens
              gap: "12px 10px",
              padding: "10px 15px",
            }}
          >
            {categories.map((category, index) => (
              <div
                key={index}
                onClick={() =>
                  handleCategorywiseProduct(
                    category?.categoryid?._id,
                    category?._id
                  )
                }
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center", // centers the CategoryCard in each cell
                }}
              >
                <CategoryCard category={category} />
              </div>
            ))}
          </div>
        )}

        {/* Slider spacing fix */}
        <style>
          {`
      .slick-slide > div {
        padding: 0 10px;
      }
      .slick-list {
        margin: 0 -10px;
      }

      @media(min-width: 1024px) {
        .category-grid-expanded {
          grid-template-columns: repeat(5, 1fr) !important;
        }
      }

      @media(max-width: 768px) {
        .category-grid-expanded {
          grid-template-columns: repeat(2, 1fr) !important;
        }
      }

      @media(max-width: 480px) {
        .category-grid-expanded {
          grid-template-columns: repeat(1, 1fr) !important;
        }
      }
    `}
        </style>
      </section>
      {/* Trending Product */}
      <section className="bestsellers">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "20px",
            fontFamily:
              '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              borderBottom: "3px solid #fbc02d",
              display: "inline-block",
              paddingBottom: "4px",
            }}
          >
            Best Selling
          </h2>
        </div>

        {/* Reduced padding on mobile */}
        <div className="container mx-auto px-2 sm:px-4 py-6">
          <Slider key={width} {...settings1}>
            {currentProducts?.map((product, index) => (
              <div key={index} className="px-2" style={{ height: "365px" }}>
                <div
                  className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Image Section */}
                  <div className="relative">
                    <div className="absolute top-3 left-3 z-10">
                      <span className="bg-[#2F4858] text-white text-xs font-semibold px-2 py-1 rounded">
                        SALE
                      </span>
                    </div>
                    <div
                      className="absolute top-3 right-3 z-10"
                      onClick={() =>
                        navigate("/singlepage", { state: product })
                      }
                    >
                      <button className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors">
                        <Eye
                          style={{ color: "#dc0000" }}
                          className="w-4 h-4 text-gray-600"
                        />
                      </button>
                    </div>
                    <div
                      className="relative"
                      style={{
                        height: "220px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate("/singlepage", { state: product })
                      }
                    >
                      <img
                        src={product.images?.[0]}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  {/* Content Section */}
                  <div
                    className="flex flex-col justify-between flex-grow"
                    style={{ padding: "0.4rem" }}
                  >
                    <div>
                      <span className="text-sm text-gray-500 block mb-1">
                        {product?.category?.name}
                      </span>
                      <h3
                        className="text-base font-semibold mb-2"
                        style={{ height: "54px" }}
                      >
                        {product?.name}
                      </h3>
                    </div>

                    {/* Desktop View: Price + Button inline */}
                    <div className="hidden sm:flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-bold">
                          ₹{product?.price.toFixed(2)}
                        </span>
                        <span className="text-gray-500 line-through text-sm">
                          ₹{product?.price?.toFixed(2)}
                        </span>
                      </div>
                      <button
                        onClick={() => HandleAddTocart(product?._id)}
                        style={{ backgroundColor: "#007bff", fontSize: "9px" }}
                        className="text-white px-3 py-1.5 rounded hover:opacity-90 transition-colors text-sm"
                      >
                        {product?.addtocartvalue
                          ? "Remove Item"
                          : "Add to Cart"}
                      </button>
                    </div>

                    {/* Mobile View: Price above, button below */}
                    <div className="flex flex-col sm:hidden gap-2 mt-2">
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-bold">
                          ₹{product?.price.toFixed(2)}
                        </span>
                        <span className="text-gray-500 line-through text-sm">
                          ₹{product?.price?.toFixed(2)}
                        </span>
                      </div>
                      <button
                        onClick={() => HandleAddTocart(product?._id)}
                        style={{ backgroundColor: "#007bff", fontSize: "10px" }}
                        className="text-white px-3 py-1.5 rounded hover:opacity-90 transition-colors text-sm w-max"
                      >
                        {product?.addtocartvalue
                          ? "Remove Item"
                          : "Add to Cart"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* New launch*/}
      <section className="bestsellers">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "20px",
            fontFamily:
              '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              borderBottom: "3px solid #fbc02d",
              display: "inline-block",
              paddingBottom: "4px",
            }}
          >
            New Launch
          </h2>
        </div>

        {/* Reduced padding on mobile */}
        <div className="container mx-auto px-2 sm:px-4 py-6">
          <Slider key={width} {...settings1}>
            {currentProducts1.map((product, index) => (
              <div key={index} className="px-2">
                <div
                  className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Image Section */}
                  <div className="relative">
                    <div className="absolute top-3 left-3 z-10">
                      <span className="bg-[#2F4858] text-white text-xs font-semibold px-2 py-1 rounded">
                        SALE
                      </span>
                    </div>
                    <div
                      className="absolute top-3 right-3 z-10"
                      onClick={() =>
                        navigate("/singlepage", { state: product })
                      }
                    >
                      <button className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors">
                        <Eye
                          style={{ color: "#dc0000" }}
                          className="w-4 h-4 text-gray-600"
                        />
                      </button>
                    </div>
                    <div
                      className="relative"
                      style={{
                        height: "220px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate("/singlepage", { state: product })
                      }
                    >
                      <img
                        src={product.images?.[0]}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  {/* Content Section */}
                  <div
                    className="flex flex-col justify-between flex-grow"
                    style={{ padding: "0.4rem" }}
                  >
                    <div>
                      <span className="text-sm text-gray-500 block mb-1">
                        {product?.category?.name}
                      </span>
                      <h3
                        className="text-base font-semibold mb-2"
                        style={{ height: "54px" }}
                      >
                        {product?.name}
                      </h3>
                    </div>

                    {/* Desktop View: Price + Button inline */}
                    <div className="hidden sm:flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-bold">
                          ₹{product?.price.toFixed(2)}
                        </span>
                        <span className="text-gray-500 line-through text-sm">
                          ₹{product?.price?.toFixed(2)}
                        </span>
                      </div>
                      <button
                        onClick={() => HandleAddTocart(product?._id)}
                        style={{ backgroundColor: "#007bff", fontSize: "9px" }}
                        className="text-white px-3 py-1.5 rounded hover:opacity-90 transition-colors text-sm"
                      >
                        {product?.addtocartvalue
                          ? "Remove Item"
                          : "Add to Cart"}
                      </button>
                    </div>

                    {/* Mobile View: Price above, button below */}
                    <div className="flex flex-col sm:hidden gap-2 mt-2">
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-bold">
                          ₹{product?.price.toFixed(2)}
                        </span>
                        <span className="text-gray-500 line-through text-sm">
                          ₹{product?.price?.toFixed(2)}
                        </span>
                      </div>
                      <button
                        onClick={() => HandleAddTocart(product?._id)}
                        style={{ backgroundColor: "#007bff", fontSize: "10px" }}
                        className="text-white px-3 py-1.5 rounded hover:opacity-90 transition-colors text-sm w-max"
                      >
                        {product?.addtocartvalue
                          ? "Remove Item"
                          : "Add to Cart"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      <section className="bestsellers">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "20px",
            fontFamily:
              '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              borderBottom: "3px solid #fbc02d",
              display: "inline-block",
              paddingBottom: "4px",
            }}
          >
            Social Media
          </h2>
        </div>

        {/* Add this */}
        <SocialMediaIcons />
      </section>

      {/* Social Media  */}
      <section className="bestsellers">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "20px",
            fontFamily:
              '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              borderBottom: "3px solid #fbc02d",
              display: "inline-block",
              paddingBottom: "4px",
            }}
          >
            Also Available On
          </h2>
        </div>

        {/* Add this */}
        <EcommerceLogos />
      </section>

      <section className="testimonials-section">
        <h2
          style={{
            marginBottom: "15px",
            fontSize: "20px",
            fontWeight: "600",
            borderBottom: "3px solid #fbc02d",
            display: "inline-block",
            paddingBottom: "4px",
          }}
        >
          Our happy clients say about us
        </h2>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">
                    ⭐
                  </span>
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="user-info">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="user-image"
                />
                <div className="user-details">
                  <h3 className="user-name">{testimonial.name}</h3>
                  <p className="user-designation">{testimonial.designation}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default QuickCardsHomePage;
